<template>
    <div id="publishTherapy">  
        
        <div v-if="paused == true" class="overflow-pause"></div>
        <div v-if="paused == true" class="paused">
            La publicación se encuentra pausada
        </div>
        <div :class="classOverlayturns"></div>
        <div :class="classturns">
            <div class="container">
                <div class="row"> 
                    <div class="col-md-6">
                        <div class="calendar" :class="CalFixHeight" v-if="typeTurn == 0">

                            <h4 class="fw-light section-title text-center text-blue">Elige un horario</h4>
                            <div class="leyed-qtySesion" v-if="qtySessions > 1 && modeId < 3">Elige la fecha y hora de tu primera sesión. Luego de realizarla podrás elegir las próximas.</div>  
                            <div class="leyed-qtySesion" v-if="qtySessions > 1 && modeId == 3">Elige la modalidad, fecha y hora de tu primera sesión. Luego de realizarla podrás elegir las próximas.</div>
                            <div v-if="modeId == 3" class="d-flex justify-content-center"> 
                                <div class="form-check m-3">
                                    <input class="form-check-input" type="radio" name="selectmode" id="selectmode1" value="1" v-model="selectMode" @click="selectMode = 1">
                                    <label class="form-check-label" for="selectmode1">
                                    Online
                                    </label>
                                </div>
                                <div class="form-check m-3">
                                    <input class="form-check-input" type="radio" name="selectmode" id="selectmode2" value="2" v-model="selectMode" @click="selectMode = 2">
                                    <label class="form-check-label" for="selectmode2">
                                    Presencial
                                    </label>
                                </div>
                            </div> 
                            <div class="print-year"><span class="badge rounded-pill bg-secondary">{{ printYear }}</span></div>
                            <button @click="prevDates()" type="button" class="nav left"><i class="las la-angle-left text-primary"></i></button>
                            <button @click="nextDates()" type="button" class="nav right"><i class="las la-angle-right text-primary"></i></button>
                            <div class="d-flex justify-content-center align-items-center h-100 w-100 waitng-prof-turns" v-if="this.showWaitCalendar == true">
                                <div>
                                    <img src="@/assets/imgs/spinner.webp" class="img-fluid w-25">
                                    Buscando horarios...
                                </div>
                            </div>
                            <div class="d-flex justify-content-center align-items-center h-100 w-100 waitng-prof-turns" v-if="this.blockUse == true || (this.cardAdded == 0 && this.userPlan < 4)">
                                <div>  
                                    <img src="@/assets/imgs/icon-calendar.png" class="img-fluid w-25">
                                    Sin horarios disponibles
                                </div>
                            </div>
                            <div class="grid">
                                <div v-for="dates in this.turns.dates" :key="dates.date" class="cell heading">
                                    <div class="day-name">{{dates.Name}}</div>
                                    <div class="day-number">{{dates.day}} {{dates.month}}</div>
                                </div>          
                                <div v-for="dates in this.turns.dates" :key="dates.date" class="row">
                                    <div class="">   
                                        <div v-for="turn in dates.turns" :key="turn.hStart" :id="'z'+dates.date.replace(/-/g,'')+turn.hStart.replace(/:/g,'')" :class="'z'+dates.date.replace(/-/g,'')+turn.hStart.replace(/:/g,'')" @click="selectTurn(turn.hStart, dates.date, convertToLocalHour(dates.date+' '+turn.hStart, dates.timezone))" class="cell item">{{convertToLocalHour(dates.date+' '+turn.hStart, dates.timezone)}}</div>
                                    </div>
                                </div>  
                            </div>
                            <h6 class="leyed-qtySesion text-center mx-auto fst-italic fw-light text-dark" style="max-width: 339px;">Los horarios que se muestran están ajustados al huso horario local de tu ciudad.</h6>
                        </div> 
                        <div class="calendar" :class="CalFixHeight" v-if="typeTurn == 1">
                            <h4 class="fw-light section-title text-center text-blue" v-if="modeId != 3">Elige un día y horario</h4>
                            <h4 class="fw-light section-title text-center text-blue" v-if="modeId == 3">Elige la modalidad, día y horario</h4>
                            <div v-if="modeId == 3" class="d-flex justify-content-center"> 
                                <div class="form-check m-3">
                                    <input class="form-check-input" type="radio" name="selectmode" id="selectmode1" value="1" v-model="selectMode" @click="selectMode = 1">
                                    <label class="form-check-label" for="selectmode1">
                                    Online
                                    </label>
                                </div>
                                <div class="form-check m-3">
                                    <input class="form-check-input" type="radio" name="selectmode" id="selectmode2" value="2" v-model="selectMode" @click="selectMode = 2">
                                    <label class="form-check-label" for="selectmode2">
                                    Presencial
                                    </label>
                                </div>
                            </div> 
                            <div class="d-flex justify-content-center align-items-center h-100 w-100 waitng-prof-turns" v-if="this.blockUse == true || (this.cardAdded == 0 && this.userPlan < 4)">
                                <div>  
                                    <img src="@/assets/imgs/icon-calendar.png" class="img-fluid w-25">
                                    Sin horarios disponibles
                                </div>
                            </div>
                            <div class="d-flex justify-content-center align-items-center h-100 w-100 waitng-prof-turns" v-if="this.showWaitCalendar == true">
                                <div>
                                    <img src="@/assets/imgs/spinner.webp" class="img-fluid w-25">
                                    Buscando horarios...
                                </div>
                            </div>
                            <div class="list-group form-dates mb-5 pb-3 pointer" v-if="turns.length > 0" style="height: -webkit-fill-available; overflow: hidden; overflow-y: auto;">  
                                <div class="list-group-item list-group-item-action" v-for="t in turns" :key="t.id" :class="'z'+t.date.replace(/-/g,'')+t.hStart.replace(/:/g,'')">
                                    <div class="d-flex justify-content-center align-items-center " @click="selectTurn(t.hStart, t.date, convertToLocalHour(t.date+' '+t.hStart, t.timezone))">
                                        <div><i class="las la-calendar"></i> <b>{{ t.startDateFormat }}</b>  - <i class="las la-clock"></i> <b>{{convertToLocalHour(t.date+' '+t.hStart, t.timezone)}}</b></div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-center align-items-center h-100 w-100 waitng-prof-turns" v-if="turns.length == 0">
                                <div>  
                                    <img src="@/assets/imgs/icon-calendar.png" class="img-fluid w-25">
                                    Sin fechas disponibles
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="d-flex justify-content-center align-items-center h-100">
                            <div v-if="!hidePrice && !noPrice" class="w-100 text-center">
                                <div class="text-center">
                                    <!--<img :src="profImg" class="img-user w-25" />-->
                                    <h4 class="fw-light text-blue">{{ profName }} {{ profLastName }}</h4>
                                    <h1 class="fw-light text-blue h5">Profesional en {{ therapy }}</h1>
                                    <p class="m-0"><b class="fw-light text-warning">{{ mode }}</b></p>
                                </div>
                                <p class="text-center title-value" v-if="promoPrice == 1">Finaliza:</p>
                                <vue-countdown v-if="promoPrice == 1" :time="counterFinish" v-slot="{ days, hours, minutes, seconds }" @end="onCountdownEnd">
                                {{ days }} Días, {{ hours }} Horas, {{ minutes }} Minutos, {{ seconds }} Segundos.
                                </vue-countdown>
                                <div class="text-center details">
                                    <span class="badge rounded-pill bg-success" v-if="promoPrice == 1"><i class="las la-bullhorn"></i> ¡Precio por tiempo limitado!</span>
                                    <span class="badge rounded-pill bg-success" v-if="fistPrice == 1 && promoPrice == 0 && fistBuyBool"><i class="las la-bullhorn"></i> ¡Primera consulta a precio diferencial!</span>
                                    <p class="title-value"  v-if="(promoPrice == 0 && fistPrice == 0) || !fistBuyBool">Valor de la consulta:</p>
                                    <div class="d-flex justify-content-center align-items-baseline" v-if="free == 0">
                                        <p class="value-old m-0" v-if="fistPrice == 1 && promoPrice == 0 && fistBuyBool"><span>{{ userCurrency }}</span>&nbsp;{{ userOldPrice }}</p>
                                        <p class="value-old m-0" v-if="promoPrice == 1"><span>{{ userCurrency }}</span>&nbsp;{{ userOldPrice }}</p>
                                        <p class="value m-0"><span>{{ userCurrency }}</span>&nbsp;{{ userPrice }}</p>
                                    </div>
                                    <div class="d-flex justify-content-center align-items-baseline" v-if="free == 1">
                                        <p class="value m-0">GRATUITA</p>
                                    </div>
                                    <div v-if="qtySessions > 1"><span class="badge rounded-pill bg-info m-2"><i class="las la-project-diagram"></i>Valor x {{ qtySessions }} Sesiones</span></div>
                                </div>
                                <div class="mb-3 d-grid gap-2 col-12 mx-auto mt-3">
                                    <button class="btn btn-primary" @click="confirmTurn()" v-if="typeTurn == 0">Reservar cita</button> 
                                    <button class="btn btn-primary" @click="confirmTurn()" v-if="typeTurn == 1 && turns.length > 0">Reservar cita</button> 
                                    <button class="btn btn-primary" v-if="typeTurn == 1 && turns.length == 0" disabled>Reservar cita</button> 
                                    <button class="btn btn-secondary" @click="closeTurns()">Cancelar</button> 
                                </div>
                            </div>
                            <div class="w-100 text-center" v-if="hidePrice || noPrice">
                                <div class="text-center details">
                                    <div v-if="qtySessions > 1"><span class="badge rounded-pill bg-info m-2"><i class="las la-project-diagram"></i>X {{ qtySessions }} Sesiones</span></div>
                                </div>
                                <div class="mb-3 d-grid gap-2 col-12 mx-auto mt-3">
                                    <button class="btn btn-primary" @click="confirmTurn()" v-if="typeTurn == 0">Reservar cita</button> 
                                    <button class="btn btn-primary" @click="confirmTurn()" v-if="typeTurn == 1 && turns.length > 0">Reservar cita</button> 
                                    <button class="btn btn-primary" v-if="typeTurn == 1 && turns.length == 0" disabled>Reservar cita</button> 
                                    <button class="btn btn-secondary" @click="closeTurns()">Cancelar</button> 
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>  
    </div>
    <div class="position-fixed bottom-0 start-0 end-0 p-0 pb-3 mx-auto" style="z-index: 110000; width: fit-content; margin-bottom: 0px;">
        <div id="toastcontainer2" class="w-100">
        </div>
    </div>
</template>
<script>
import axios from "axios";
import { Toast } from 'bootstrap'
import VueCountdown from '@chenfengyuan/vue-countdown';
export default { 
    name: "buyAgain",
    props: ['publishId'],
    components: {
        VueCountdown,
    }, 
    data(){
        return{    
            errorText: '',
            toastColor: '',
            toastBg: '',
            toastNumber: 0, 
            showWaitCalendar: false, 
            ref: '',
            therapy: '',
            title: '',
            mode: '',
            payCash: 0,
            payCard: 0,
            payCashLimit: 0,
            payAfter: 0,
            profRef: '',
            profName: '',
            profLastName: '',
            profImg: '',
            fistPrice: 0,
            promoPrice: 0,
            userCurrency: '',
            userPrice: '',
            userOldPrice: '',
            userIp: '',
            userCountry: '',
            profCountry: '',
            duration: '',
            realPriceLocal: 0, //precio local normal
            realPriceInter: 0, //precio internacional normal
            firstPriceLocal: 0, //precio local primera consulta
            firstPriceInter: 0, //precio internacional primera consulta
            promoPriceLocal: 0, //precio local promocion
            promoPriceInter: 0, //precio internacional promocion
            counterFinish: '',
            promoStartDate: '',
            promoFinishDate: '', 
            flagCountDownRun: false,
            days: '',
            localZone: '',
            turns: [],
            classOverlayturns: 'overlayturns',
            classturns: 'turns',
            paused: false,
            findDate: 0,
            dataReceiver: '',
            loading: false,
            disabled: false,
            next: 0,
            printYear: '',
            hourSelected: '', //hora del profesional
            dateSelected: '',
            hourUserSelected: '', //hora del usuario
            therapyId: '',
            payRealPrice: 0,
            flagCurrency: false,
            modeId: 0,
            free: false,
            hidePrice: false,
            noPrice: false,
            blockUse: false,
            userPlan: 0,
            cardAdded: 1,
            fistBuyBool: true,    
            typeTurn: 2,
            qtySessions: 0,
            CalFixHeight: '',
            selectMode: 0,
            platformVideoCall: 'Animasana',
            linkVideoCall: '',
            passVideoCall: '',
            roomIdLink: '',
            maxRes: 0,
            admin: '',
        }
    },
    mounted: function () { 
        window.scrollTo(0, 0);
        
        this.findIp();
        
        this.ref = this.publishId;
        this.getPublish();
        var element =  document.getElementById('momentScript');
        if (typeof(element) != 'undefined' && element != null){
            this.findTurns(0, 'next');
        }else{       
            const plugin = document.createElement("script");
            plugin.setAttribute("src", "https://cdn.jsdelivr.net/npm/moment@2.27.0/min/moment.min.js");
            plugin.setAttribute("id", "momentScript");
            plugin.async = false;
            document.head.appendChild(plugin);
            const plugin2 = document.createElement("script");
            plugin2.setAttribute("src", "https://cdnjs.cloudflare.com/ajax/libs/moment-timezone/0.5.34/moment-timezone-with-data-10-year-range.js");
            plugin2.setAttribute("id", "momentScriptYears");
            plugin2.async = false;
            document.head.appendChild(plugin2);
            var f = this;
            plugin.addEventListener('load', function() {
                plugin2.addEventListener('load', function() {
                    f.findTurns(0, 'next');
                });
            }); 
        }
        
        if(localStorage.getItem('token') && localStorage.getItem('question'+this.ref)){
            var e = JSON.parse(localStorage.getItem('question'+this.ref));
            var now = new Date().getTime();
            var dateQuestion = new Date(e.date).getTime();
            var diff = now - dateQuestion;
            this.question = e.question;
            if(diff < 300000){  
                this.sendQuestion();
            }   
        }
        if(localStorage.getItem('token')){
            this.checkFirstBuy();
        }
       
    },
   
    methods:{
        
        async findUserData(){    
            var payload = {
                action: 'find-user-data',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.profRef,      
            }       
            await axios.post('/index.php', payload).then(result => {
                this.blockUse = result.data.blockUse; 
                this.cardAdded = result.data.card_added;
                this.userPlan =  result.data.userPlan; 
                if(this.userPlan == '4'){
                    this.blockUse = false;
                } 
            })
            .catch(error => {
               
            })     
        },
        confirmTurn(){
            if(this.modeId == '3'){
                if(this.selectMode == '0'){
                    this.errorText = 'Debes seleccionar la modalidad.';
                    this.toastBg = 'bg-info';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer2').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){
                        console.log(e)
                    }	
                    return;
                }
                
            }else{
                this.selectMode = this.modeId;
            }
            if(this.hourSelected == '' && this.hourUserSelected == '' && this.dateSelected == ''){
                this.errorText = 'Debes seleccionar un horario.';
                this.toastBg = 'bg-info';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer2').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }	
                return;
            }    
            
            var d = new Date().toISOString().substr(0, 19).replace('T', ' ');
            var datestring = d;             
            localStorage.setItem('cart', JSON.stringify({ref: this.ref,title: this.title, profetional: this.profName +' '+ this.profLastName, originaHour: this.hourSelected, userHour:  this.hourUserSelected, dateSelected: this.dateSelected, img: this.profImg, duration: this.duration, fistPrice: this.fistPrice, promoPrice: this.promoPrice, userCurrency: this.userCurrency, userPrice: this.userPrice, userOldPrice: this.userOldPrice, userIp: this.userIp, userCountry: this.userCountry, profCountry: this.profCountry, realPriceLocal: this.realPriceLocal, realPriceInter: this.realPriceInter, firstPriceLocal: this.firstPriceLocal, firstPriceInter: this.firstPriceInter, promoPriceLocal: this.promoPriceLocal, promoPriceInter: this.promoPriceInter, therapyId: this.therapyId, profRef: this.profRef, payRealPrice: this.payRealPrice, totalAmmountOldNoFormat: this.payRealPrice, flagCurrency: this.flagCurrency, payCash: this.payCash, payCard: this.payCard, duration: this.duration, modeId: this.selectMode, date: datestring, coupon: '', firstBuyBook: this.fistBuyBool, qtySessions: this.qtySessions, limitTime: '',  limitTimeDays: '', hidePrice: this.hidePrice, noPrice: this.noPrice, giftId: '', platformVideoCall: this.platformVideoCall, linkVideoCall: this.linkVideoCall, passVideoCall: this.passVideoCall, roomIdLink: this.roomIdLink, bookId: '', productType: 1, products: [], shipmentMode: 0, shipmentAddressId: 0, payCashLimit: this.payCashLimit, admin: this.admin}));

            this.$router.push({ name: 'confirmation-cart-landing'});
            
        },
        selectTurn(hour, date, hourUser){   
            var elems = document.querySelectorAll(".cell.item.active");
            [].forEach.call(elems, function(el) {
                el.classList.remove("active");
            });
            this.hourSelected = hour;
            this.hourUserSelected = hourUser;
            this.dateSelected = date;
            var selector = '.z'+date.replace(/-/g,'')+hour.replace(/:/g,'');
            try{
                var elems = document.querySelectorAll(selector);
                [].forEach.call(elems, function(el) {
                    el.classList.add("active");
                });
            }catch(e){

            } 
        },
        async report(val, ref){
            var payload = {
                action: 'report-question',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: localStorage.getItem('token'),
                ref: ref,
                answer: val,
            }
            await axios.post('/index.php', payload).then(result => {
               if(result.data.status == '200'){
                   if(val == 'q'){
                       this.errorText = 'Revisaremos la pregunta. Si no cumple con las políticas de Animasana será eliminada.';
                       document.querySelector('#r-q'+ref).style.display = 'none';
                   }else{
                       this.errorText = 'Revisaremos la respuesta. Si no cumple con las políticas de Animasana será eliminada.';
                       document.querySelector('#r-a'+ref).style.display = 'none';
                   }   
                    this.toastBg = 'bg-info';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer2').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }	
                    return;                
                }    
            })
            .catch(error => {
                this.loading = false;
                this.disabled = false;
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer2').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }	
                return;
            })
        }, 
        async findQuestions(){
            var payload = {
                action: 'find-questions',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.ref, 
                mode: 3,
                next: this.next,
                filter: 0
            }
            await axios.post('/index.php', payload).then(result => {
                let sum = 0;
                Object.keys(result.data).forEach(key => {
                    this.questions.push( result.data[sum]);
                    
                    sum++;
                });
                this.questionsEnd = sum;      
                this.next = this.next+10;              
            })
            .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer2').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }	
                return;
            })
        },
        openTurns(){
            //this.findTurns(0, 'next');
            this.classOverlayturns = 'overlayturns in';
            this.classturns = 'turns in';
        },
        closeTurns(){
            this.classOverlayturns = 'overlayturns';
            this.classturns = 'turns';
            this.$parent.closeBuyAgain();
        },
        convertToLocalHour(hour, timezone){
            let horaProf = moment.tz(hour, "YYYY-MM-DD HH:mm", timezone);
            let horaCons = horaProf.clone().tz(this.localZone);

            // Detectar si la zona local es una zona horaria de México
            const zonasMexico = [
                'America/Mexico_City',
                'America/Cancun',
                'America/Monterrey',
                'America/Merida',
                'America/Mazatlan',
                'America/Chihuahua',
                'America/Hermosillo',
                'America/Ojinaga',
                'America/Bahia_Banderas'
            ];

            if (zonasMexico.includes(this.localZone) && zonasMexico.includes(timezone) && this.localZone !== timezone) {

                // Calcular diferencia real entre zonas horarias
                const offsetProf = horaProf.utcOffset();     // en minutos
                //const offsetMexico = moment.tz(hour, "YYYY-MM-DD HH:mm", 'America/Mexico_City').utcOffset(); // en minutos
                //const diferenciaReal = (offsetProf - offsetMexico) / 60;
                const offsetLocal = moment.tz(hour, "YYYY-MM-DD HH:mm", this.localZone).utcOffset(); // en minutos
                const diferenciaReal = (offsetProf - offsetLocal) / 60;
                
                // Aplicar la diferencia real + 1 hora adicional
                const totalAjuste = diferenciaReal + 1;

                horaCons = horaProf.clone().subtract(totalAjuste, 'hours');  
            }

            return horaCons.format("HH:mm");
        },
        prevDates(){   
            if(this.findDate > 0){
                let val = (this.findDate - 5)
                this.findDate = val;
                this.findTurns(this.findDate, 'prev');
                this.hourSelected = '';
                this.hourUserSelected = '';
                this.dateSelected = '';
            }else{
                this.errorText = 'Fechas no disponibles.';
                this.toastBg = 'bg-info';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer2').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }	
            }
            
        },
        nextDates(){
            let val = (this.findDate + 5)
            if(val >= this.maxRes){
                this.errorText = 'Próximas fechas no disponibles.';
                this.toastBg = 'bg-info';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer2').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }	
                return;
            }
            this.findDate = val;
            this.findTurns(this.findDate, 'next');
            this.hourSelected = '';
            this.hourUserSelected = '';
            this.dateSelected = '';
        },      
        async findTurns(val, val2){
            var d = new Date();
            d = d.getHours()+':'+d.getMinutes();
            this.localZone =  moment.tz.guess();
            var payload = {
                action: 'find-turns',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                ref: this.ref,
                from: val,
                move: val2,
                userTime: d,  
            }
            this.showWaitCalendar = true;
            await axios.post('/index.php', payload)
            .then(result => {
                this.showWaitCalendar = false;
                if(!this.blockUse || (this.cardAdded == 1 && this.userPlan < 4)){
                    if(this.typeTurn == 0){
                        this.turns = result.data; 
                        this.findDate = result.data.from;
                        var y = new Date(result.data.dates[4].date);
                        y = y.getFullYear()
                        this.printYear = y;
                    }else if(this.typeTurn == 1){
                        this.turns = result.data.dates; 
                        this.turns.sort((a, b) => Number(new Date(a.date + ' '+ a.hStart)) - Number(new Date(b.date + ' '+ b.hStart)));
                    }  
                }

            })
            .catch(error => {
                    this.loading = false;
                    this.disabled = false;
                    this.errorText = 'Revise su conexión de internet.';
                    this.toastBg = 'bg-danger';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer2').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }	
                    return;
                })
        },
        onCountdownEnd(){
            if(this.flagCountDownRun == true){
                this.promoPrice = 0;
                this.printValues();
            }        
        },
        findIp(){
            if(!localStorage.getItem('token')){
                fetch('https://api.ipify.org?format=json')
                .then(x => x.json())
                .then(({ ip }) => {
                    this.userIp = ip;
                    this.findCountry()
                }).catch(error => {
                    this.userIp = '152.169.170.119';
                    this.findCountry()
                });
            }else{   
                var d = JSON.parse(localStorage.getItem('userData'));
                localStorage.setItem('userCountryId', d.userCountry);
                this.userCountry = d.userCountry;
                //this.findUserCurrency();
            }  
        },
        async checkFirstBuy(){
            var payload = {
                action: 'check-first-buy',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: localStorage.getItem('token'),
                publishId: this.ref
            }
            await axios.post('/index.php', payload).then(result => {
                this.fistBuyBool = result.data.fistBuyBool;
                this.printValues();
            })

        },
        async findCountry(){
            var payload = {
                action: 'geo-country-location',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                ip: this.userIp
            }
            await axios.post('/index.php', payload).then(result => {
                this.userCountry = result.data.country;
                localStorage.setItem('userCountryId', this.userCountry);
                this.printValues();
                /*if(!localStorage.getItem('currencyCode')){
                    this.findUserCurrency();
                }else{
                    this.userCurrency = localStorage.getItem('currencyCode');    
                }*/
            })
        },
        printValues(){
            if(this.promoPrice == 1){
                let now =  new Date(); 
                this.promoStartDate = new Date(this.promoStartDate);
                this.promoFinishDate = new Date(this.promoFinishDate); 
                if (this.promoStartDate > now){
                    this.promoPrice = 0;
                }else if (this.promoFinishDate < now){
                    this.promoPrice = 0;
                }else{
                    this.counterFinish = this.promoFinishDate - now;  
                    this.flagCountDownRun = true;    
                }  
            }   
            if(this.userCountry == this.profCountry){
                this.flagCurrency = false;
                if(this.promoPrice == 1){ //promo
                    var priceA = this.promoPriceLocal;
                    var priceB = this.realPriceLocal;
                    this.payRealPrice = priceA;
                    this.convertPrice(priceA, 'price', 'yes');
                    this.convertPrice(priceB, 'oldPrice', 'yes');
                }else if(this.fistPrice == 1 && this.fistBuyBool){ //primera consulta  
                    var priceA = this.firstPriceLocal;
                    var priceB = this.realPriceLocal;
                    this.payRealPrice = priceA;
                    this.convertPrice(priceA, 'price', 'yes');
                    this.convertPrice(priceB, 'oldPrice', 'yes');
                }else{
                    var priceA = this.realPriceLocal; 
                    this.payRealPrice = priceA;
                    this.convertPrice(priceA, 'price', 'Yes');
                    this.userOldPrice = '';
                }   
                this.findUserCurrency();
               /* if(!localStorage.getItem('currencyCode')){
                    this.findUserCurrency();
                }else{
                    this.userCurrency = localStorage.getItem('currencyCode');      
                }*/
            }else{
                this.flagCurrency = true;
                if(this.promoPrice == 1){ //promo
                    //convertimos los valores a la moneda del usuario
                    var priceA = this.promoPriceInter;
                    var priceB = this.realPriceInter;
                    this.payRealPrice = priceA;
                    this.convertPrice(priceA, 'price', 'Yes');
                    this.convertPrice(priceB, 'oldPrice', 'Yes');
                }else if(this.fistPrice == 1  && this.fistBuyBool){ //primera consulta
                    var priceA = this.firstPriceInter;
                    var priceB = this.realPriceInter;
                    this.payRealPrice = priceA;
                    this.convertPrice(priceA, 'price', 'Yes');
                    this.convertPrice(priceB, 'oldPrice', 'Yes');
                }else{
                    var priceA = this.realPriceInter; 
                    this.payRealPrice = priceA;
                    this.convertPrice(priceA, 'price', 'Yes');
                    this.userOldPrice = '';
                } 
                this.userCurrency = "USD";  
            }
        },
        async convertPrice(val, val2, val3){
            var payload = {
                action: 'convert-price',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                userCountryId: this.userCountry,
                userCurrency: this.userCurrency,
                profCurrency: 'USD',
                onlyFormat: val3,
                price: val
            }
            await axios.post('/index.php', payload).then(result => {
                if(val2 == 'price'){
                    this.userPrice = result.data.price;
                }else if(val2 == 'oldPrice'){
                    this.userOldPrice = result.data.price;
                }
            })         
        },
        async getPublish(){  
            var payload = {
                    action: 'get-publish',
                    browserCountry: this.$route.params.browserCountry,
                    userLang: this.$route.params.userLang,
                    urlcode: window.location.host,
                    dataReceiver: this.dataReceiver,
                    localCurrency: false,
                    ref: this.ref,
                    mode: 'noencrypt'

                } 
                await axios.post('/index.php', payload)
                .then(result => { 
                    this.admin = result.data[0].admin;
                    if(result.data[0].therapyId == 0){
                        this.therapy = result.data[0].therapyOther;
                    }else{
                        this.therapy = result.data[0].therapy;
                    }
                    this.therapyId = result.data[0].therapyId;
                    this.title = result.data[0].title;
                    if(result.data[0].maxRes == '1'){
                        this.maxRes = 30;
                    }else if(result.data[0].maxRes == '2'){
                        this.maxRes = 60;
                    }else if(result.data[0].maxRes == '3'){
                        this.maxRes = 90;
                    }else if(result.data[0].maxRes == '4'){
                        this.maxRes = 120;
                    }else if(result.data[0].maxRes == '5'){
                        this.maxRes = 150;
                    }else if(result.data[0].maxRes == '6'){
                        this.maxRes = 180;
                    }else if(result.data[0].maxRes == '7'){
                        this.maxRes = 365;
                    }else if(result.data[0].maxRes == '8'){
                        this.maxRes = 730;
                    }else if(result.data[0].maxRes == '9'){
                        this.maxRes = 7;
                    }else if(result.data[0].maxRes == '10'){
                        this.maxRes = 14;
                    }
                    this.twitterLink = 'https://twitter.com/intent/tweet?text='+this.title+'&amp;url='+window.location.href;
                    this.facebookLink = 'https://www.facebook.com/sharer?u='+window.location.href;
                    this.whatsappLink = 'https://api.whatsapp.com/send?text='+this.title+' '+window.location.href;
                    this.sintomasSel = [];
                    if(result.data[0].symptom.length > 0){  
                       for (var i = 0; i < result.data[0].symptom.length; i++) {
                           this.sintomasSel.push({id: result.data[0].symptom[i].id, name: result.data[0].symptom[i].name});
                       }   
                    }
                    this.description = result.data[0].description;  
                    this.mode = result.data[0].modality;
                    this.modeId = result.data[0].modalityId;
                    this.langTextAl = result.data[0].langTextAl;
                    this.langTextEn = result.data[0].langTextEn;
                    this.langTextEs = result.data[0].langTextEs;
                    this.langTextFr = result.data[0].langTextFr;
                    this.langTextIt = result.data[0].langTextIt;
                    this.langTextPo = result.data[0].langTextPo;
                    this.payCash = result.data[0].payCash;
                    this.payCard = result.data[0].payCard;
                    this.payCashLimit = result.data[0].payCashLimit;
                    this.payAfter = result.data[0].payAfter;
                    this.arrayImgs = []; 
                    if(result.data[0].imagesBig.length > 0){ 
                        var count = 0
                        for (var i = 0; i < result.data[0].imagesBig.length; i++) {
                            let arrayImg = { index: count, id: result.data[0].imagesBig[i].id, link: result.data[0].imagesBig[i].link };
                            this.arrayImgs.push(arrayImg)   
                            count++;  
                        }
                    }
                    this.vimeoID = result.data[0].video;
                    this.profRef = result.data[0].userId;
                    this.isAnimasana = result.data[0].isAnimasana;
                    this.realPriceLocal = result.data[0].realPriceLocal;
                    this.realPriceInter = result.data[0].realPriceInter;
                    this.firstPriceLocal = result.data[0].firstPriceLocal;
                    this.firstPriceInter = result.data[0].firsPriceInter;
                    this.promoPriceLocal = result.data[0].promoPriceLocal;
                    this.promoPriceInter = result.data[0].promoPriceInter;
                    this.fistPrice = result.data[0].praConsulta;
                    this.promoPrice = result.data[0].promo;
                    this.duration = result.data[0].duration;
                    this.days = result.data[0].days;
                    this.payCash = result.data[0].payCash;
                    this.payCard = result.data[0].payCard;
                    this.userCurrency = result.data[0].userCurrency;
                    this.typeTurn = result.data[0].typeTurn;
                    this.qtySessions = result.data[0].qtySessions;
                    if(this.qtySessions > 1){
                        this.CalFixHeight = 'fix-height';
                    }
                    if(this.modeId == '3'){
                        this.CalFixHeight = this.CalFixHeight +' fix-mode';
                    }
                    if(result.data[0].hidePrice == 0){
                        this.hidePrice = false;
                    }else{
                        this.hidePrice = true;
                    }
                    if(result.data[0].free == 0){
                        this.free = false;
                    }else{
                        this.free = true;
                    }
                    if(result.data[0].noPrice == 0){
                        this.noPrice = false;
                    }else{
                        this.noPrice = true;
                    }
                    if(result.data[0].paused == '1'){
                        this.paused = true;
                        document.querySelector('#publishTherapy').classList.add('paused');
                    }
                    this.platformVideoCall = result.data[0].platformVideoCall;
                    this.linkVideoCall = result.data[0].linkVideoCall;
                    this.passVideoCall = result.data[0].passVideoCall;
                    this.roomIdLink = result.data[0].roomIdLink; 
                    if(this.modeId == 1 || this.modeId == 3){
                        if(this.platformVideoCall == ''){
                            this.platformVideoCall = "Animasana";
                        }
                        this.checkPlatform();
                    }
                    //BUSCAMOS EL PAIS DEL PROFESIONAL
                    this.findUserData();
                    this.findAddressInfo();
                    this.findUserInfo();
                    this.openTurns();
                    if(result.data[0].promo == 1){
                        this.promoStartDate = result.data[0].promoStartDate;
                        this.promoFinishDate = result.data[0].promoFinishDate;      
                    }
                    return   
                })            
                .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer2').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }	
                return;

            })
        },
        async findUserInfo(){
            if(this.admin == ''){
                var payload = {
                    action: 'find-user-info',
                    browserCountry: this.$route.params.browserCountry,
                    userLang: this.$route.params.userLang,
                    urlcode: window.location.host,
                    dataReceiver: this.profRef    
                }
            }else{
                var payload = {
                    action: 'find-user-info',
                    browserCountry: this.$route.params.browserCountry,
                    userLang: this.$route.params.userLang,
                    urlcode: window.location.host,
                    dataReceiver: this.admin    
                }
            }
            await axios.post('/index.php', payload)
            .then(result => {
                 if(result.data.status == '200'){
                    this.profName = result.data.userFirstName;
                    this.profLastName = result.data.userLastName;
                    if(result.data.userImg != ''){
                        this.profImg = result.data.userImg;
                    }           
                 }  
            })
            .catch(error => {
                    this.loading = false;
                    this.disabled = false;
                    this.errorText = 'Revise su conexión de internet.';
                    this.toastBg = 'bg-danger';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer2').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }	
                    return;
                })
        },

        async findAddressInfo(){
            var payload = {
                action: 'find-user-address',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.profRef     
            }
            await axios.post('/index.php', payload)
            .then(result => {
                 if(result.data.status == '200'){
                     this.profCountry = result.data.userCountryCode;
                     //this.profCountry = '80';
                     
                     //BUSCAMOS EL PAIS DEL USUARIO
                     if(!localStorage.getItem('userCountryId')){
                         this.findIp();
                     }else{
                         this.userCountry = localStorage.getItem('userCountryId');
                        /*if(!localStorage.getItem('currencyCode')){
                            this.findUserCurrency();
                        }else{
                            this.userCurrency = localStorage.getItem('currencyCode');    
                        } */
                         this.printValues();
                     }

                 }  
            })
            .catch(error => {
                this.loading = false;
                this.disabled = false;
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer2').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }	
                return;
            })
        },
        async findUserCurrency(){
            var payload = {
                action: 'find-currency',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                userCountry: this.profCountry     
            }
            await axios.post('/index.php', payload)
            .then(result => {             
                this.userCurrency = result.data[0].name;;
                //localStorage.setItem('currencyCode', this.userCurrency);   
            })
            .catch(error => {
                this.loading = false;
                this.disabled = false;
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer2').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }	
                return;
            })
        },
        checkPlatform(){
            if(this.platformVideoCall == 'Meet'){
                this.findCalendar();
            }else if(this.platformVideoCall == 'Zoom'){
                
                this.findZoom();
            }
        },
        async findCalendar(){ 
            this.disabled = true;
            var payload = {
                action: 'find-calendar',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.profRef
            }
            await axios.post('/index.php', payload)
            .then(result => {
                this.waitingCal = false;
                if(result.data.status == '200'){
                    if(result.data.connected == 'true'){ 
                    }else{
                        this.platformVideoCall = "Animasana";
                    }    
                }   
            })
            .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer2').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }
                return;
            })
        },
        async findZoom(){ 
            this.disabled = true;
            var payload = {
                action: 'find-zoom-connect',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.profRef
            }
            await axios.post('/index.php', payload)
            .then(result => {
                this.waitingCal = false;
                if(result.data.status == '200'){
                    if(result.data.connected == 'true'){ 
                    }else{
                        this.platformVideoCall = "Animasana";
                    }   
                }   
            })
            .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer2').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }
                return;
            })
        },
    }
}
</script>
<style scoped>
#publishTherapy .calendar.fix-height{
    height: 490px;
}
#publishTherapy .calendar.fix-mode{
    height: 490px;
}
#publishTherapy .calendar.fix-height.fix-mode{
    height: 523px;
}
.waitng-prof-turns{
    position: absolute;
    background: #ffffff99;
    width: 100%;
    z-index: 1;
    color: #4586e6;
    left: 0;
    top: 0;
    text-align: center;
}  
#publishTherapy .grid .cell.heading {
    text-align: center;
    padding: 4px 0px;
}
#publishTherapy .print-year {
    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
    color: #2496ff;
    text-align: center;
    margin: 0;
}
#publishTherapy .grid .row{
    height: 246px;
}
#publishTherapy .calendar button.nav{
    top: 93px;
}
#publishTherapy .calendar.fix-height button.nav{
    top: 125px;
}
#publishTherapy .calendar.fix-mode button.nav{
    top: 148px;
}
#publishTherapy .calendar.fix-height.fix-mode button.nav{
    top: 179px;
}
@media (min-width: 780px){
    #publishTherapy .turns {
        height: 61%;
        display: flex;
        align-items: center;
    }
    #publishTherapy .grid .row>*{
        padding: 5px;
    }
}
@media (max-width: 780px){
    #publishTherapy .calendar {
        height: 447px;
    }
    #publishTherapy .calendar button.nav{
        top: 99px;
    }
    #publishTherapy .calendar.fix-height button.nav{
        top: 145px;
    }
    #publishTherapy .calendar.fix-mode button.nav{
        top: 153px;
    }
    #publishTherapy .calendar.fix-height.fix-mode button.nav{
        top: 193px;
    }
    #publishTherapy .grid .row{
        height: 227px;
    }
    #publishTherapy .grid .cell.item{
        padding: 8px 0px;
    }
}
@media (min-width: 780px){
    #publishTherapy .grid .row{
        margin: 0;
    }
    #publishTherapy .grid .row::-webkit-scrollbar-thumb{

    }
    #publishTherapy .grid .row::-webkit-scrollbar{
        width: 5px;
    }
}
.user-social{
    border-radius: 50%;
    width: 38px;
    padding: 6px;
    height: 38px;
    margin: 0 2px;
    background-color: #5792e8;
    border-color: #5792e8;
}
.user-social:hover{
    background-color: #3876d1;
    border-color: #3876d1;
}
#publishTherapy .img-user {
    width: 96px;
    transform: translateY(-75px);
}
#publishTherapy .hero-section1 h1, #publishTherapy .hero-section1 h3, #publishTherapy .hero-section1 h4, #publishTherapy .hero-section1 div.text-warning {
    transform: translateY(-63px);
}
@media (max-width: 780px){
    #publishTherapy .hero-section1 .hero-content {
        margin-top: 0;
        margin-bottom: -100px;
    }
}
#publishTherapy .grid .cell.item.active {
    border: 1px solid rgb(0, 133, 255);
    box-shadow: rgb(0, 133, 255) 0px 0px 3px inset;
    background: rgb(0, 133, 255);
    color: #fff;
}
.leyed-qtySesion{
    font-size: 12px;
    color: #7b7b7b;
    margin: 0 10px;
    line-height: 12px;
    text-align: center;
    margin-bottom: 10px;
}
</style>